module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"hotlist_status":"Hotlist Status 🔥","loading":"Wird geladen..."}}')
  delete Component.options._Ctor
}
